module.exports = __webpack_public_path__ + "static/media/REN-logo.97560b1b.png";